import { ButtonAsLink } from '@cluey/cluey-components';
import { useEffect, useState } from 'react';

const COOLDOWN_SECONDS = 60;

export type ResendCodeProps = {
  onClick: () => void;
};

const ResendCode = ({ onClick }: ResendCodeProps) => {
  const [secondsLeft, setSecondsLeft] = useState(COOLDOWN_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const id = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);

  const handleResend = () => {
    onClick();
    setSecondsLeft(COOLDOWN_SECONDS);
  };

  const canResend = secondsLeft === 0;

  return (
    <p>
      Didn't receive the code?{' '}
      {canResend ? (
        <ButtonAsLink className="link" onClick={canResend ? handleResend : undefined} disabled={!canResend}>
          Resend email
        </ButtonAsLink>
      ) : (
        <span>Resend in {secondsLeft}s</span>
      )}
    </p>
  );
};

export default ResendCode;
